import moment from 'moment';

export const dateDisplayFormatNoTimezone = 'YYYY-MM-DD HH:mm:ss';
export const dateDisplayFormatNoTimezoneNoTime = "YYYY-MM-DD";

export const getTimeNoUTC = (dateStr) => {
  return moment.utc(dateStr).format(dateDisplayFormatNoTimezone);
}; 

export const getTimeNoUTCNoTime = (dateStr) => {
  return moment.utc(dateStr).format(dateDisplayFormatNoTimezoneNoTime);
}